import React from "react";
import { Props } from "./types";

function ResizeIcon(props: Props) {
  return (
    <svg className={props.className} viewBox="0 0 13.278 5.711">
      <path
        id="Icon_awesome-arrows-alt-h"
        d="M9.8,10.882v1.195H3.477V10.882a.622.622,0,0,0-1.063-.44L.182,12.673a.622.622,0,0,0,0,.88l2.232,2.232a.622.622,0,0,0,1.063-.44V14.151H9.8v1.195a.622.622,0,0,0,1.063.44L13.1,13.554a.622.622,0,0,0,0-.88l-2.232-2.232a.622.622,0,0,0-1.063.44Z"
        transform="translate(0 -10.258)"
      />
    </svg>
  );
}

export { ResizeIcon };
